import styled from 'styled-components';

export const InfoSection = styled.div<{ textAlign?: 'left' | 'right' }>`
  flex: 1;
  text-align: ${(props) => props.textAlign || 'left'};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
`;

export const ValidityLabel = styled.div`
  color: #8c8c8c;
  font-weight: 400;
  font-size: 0.625rem;
  line-height: 1.2;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`;

export const DateLine = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
`;

export const AuctionText = styled.span`
  color: #000;
  font-weight: 400;
  font-size: 0.625rem;
`;

export const DateText = styled.span`
  color: #389e0d;
  font-weight: 700;
  font-size: 0.625rem;
`;

export const UntilText = styled.span`
  color: #000;
  font-weight: 400;
  font-size: 0.625rem;
`;
